import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

let registered = false;

export const prefersReducedMotion = () =>
  typeof window !== 'undefined' &&
  window.matchMedia('(prefers-reduced-motion: reduce)').matches;

export const isMobileViewport = () =>
  typeof window !== 'undefined' && window.matchMedia('(max-width: 767px)').matches;

export const setupGsap = () => {
  if (registered) return gsap;
  gsap.registerPlugin(ScrollTrigger);
  gsap.defaults({ ease: 'power3.out', duration: 1 });
  if (typeof window !== 'undefined') {
    window.gsap = gsap;
    window.ScrollTrigger = ScrollTrigger;
  }
  registered = true;
  return gsap;
};

export const refreshScrollTrigger = () => {
  setupGsap();
  ScrollTrigger.refresh();
};

export { gsap, ScrollTrigger };
